import { FieldObjectType } from 'module/api/field/types';
import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { ActionBar } from 'module/ui/components/molecules/action-bar';
import { HeaderWithIconTitle } from 'module/ui/components/molecules/page/page';
import { Argon as ArgonTemplate } from 'module/ui/components/templates/argon';
import { Content } from 'module/ui/components/templates/argon/components';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@rocketlane/ui';
import { useGetAllEmailFieldsQuery } from 'queries/fields';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SignalFieldsList } from 'components/organisms/signal-fields/list';
import { ManageFieldDrawer } from 'components/organisms/signal-fields/manage-field-drawer';
import { useManageFieldDrawerState } from 'components/organisms/signal-fields/manage-field-state';

const Argon = styled(ArgonTemplate)`
  ${Content} {
    border: none;
  }
  ${ActionBar} {
    box-shadow: none;
  }
`;

export const EmailFieldsPage = () => {
  const title = useTranslation('email_fields');
  const { data: emailFields, isLoading: isEmailFieldsLoading } =
    useGetAllEmailFieldsQuery();
  const {
    drawerState,
    closeDrawer,
    openDrawerInCreateMode,
    openDrawerInEditMode,
  } = useManageFieldDrawerState();

  return (
    <Argon
      documentTitle={title}
      title={
        <HeaderWithIconTitle
          icon={<FontAwesomeIcon icon={faEnvelope} size={20} />}
          title={title}
        />
      }
      description={<FormattedMessage id="settings.email_fields.description" />}
      actions={
        isEmailFieldsLoading
          ? {}
          : {
              secondary: (
                <Button
                  leftIcon={<FontAwesomeIcon icon={faPlus} />}
                  variant="primary"
                  onClick={openDrawerInCreateMode}
                >
                  <FormattedMessage id="settings.email_fields.create_field" />
                </Button>
              ),
            }
      }
      content={
        isEmailFieldsLoading ? (
          <PageLoading />
        ) : (
          <>
            <SignalFieldsList
              fields={emailFields ?? []}
              onEdit={openDrawerInEditMode}
            />
            <ManageFieldDrawer
              onClose={closeDrawer}
              visible={drawerState.visible}
              field={drawerState.field}
              fieldObjectType={FieldObjectType.Email}
            />
          </>
        )
      }
    ></Argon>
  );
};
